
















































































import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import Card from '@/components/Card.vue'
import ChainDetails from './components/ChainDetails.vue'
import TaskDetails from '../../components/TaskDetails.vue'
import { UserModule } from '@/store/modules/user.module'
import { ChainModule } from '@/store/modules/chain.module'
import ChainComments from '../../components/BaseComments.vue'
import OnboardingDetails from './components/OnboardingDetails.vue'
import GoBack from '@/components/GoBack.vue'
import AllTasks from '../../components/AllTasks.vue'
import api from '@/api'
import Icon from '@/components/Icon.vue'
import { NoCache } from '@/decorators/NoCache'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { EUserStatus, IChain } from '@zunta/configurations'
import { PermissionsModule } from '@/store/modules/permissions.module'
import ButtonWithDropdown from '@/components/ButtonWithDropdown.vue'

@Component({
  components: {
    ButtonWithDropdown,
    Card,
    TaskDetails,
    ChainDetails,
    ChainComments,
    OnboardingDetails,
    GoBack,
    AllTasks,
    Icon,
    LoaderWrapper
  }
})
export default class ChainPage extends Vue {
  permissionsModuleInstance: PermissionsModule = getModule(PermissionsModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store);
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store);
  isLoading = true
  showAllTasks: boolean = false

  @NoCache
  get todosPagination () {
    return this.$store.state.user.todosPagination
  }

  get todoId () {
    return this.$route.params.todo
  }

  get chain () {
    return this.$store.state.chain.chain
  }

  get onboardingData () {
    return this.$store.state.chain.onboardingData
  }

  get chainId () {
    return this.$route.params.id
  }

  get assignedTo () {
    return this.$route.query.assignedTo
  }

  get rolesList () {
    return this.$store.state.permissions.roles
  }

  get dropdownOptions () {
    return (this.rolesList || []).map((role: any) => {
      return {
        key: role.id,
        value: role.id,
        content: role.name
      }
    })
  }

  async mounted () {
    await this.fetchData()
    this.$watch('todoId', async (value1: any, value2: any) => {
      if (+value1 !== +value2) {
        await this.fetchData()
        this.$forceUpdate()
      }
    })
  }

  goUpdateChain () {
    this.$router.push({ name: 'admin-update-chain', params: { id: this.chainId } })
  }

  fetchComments () {
    this.chainModuleInstance.fetchChainComments(this.chainId)
  }

  async fetchData () {
    this.isLoading = true
    await this.chainModuleInstance.fetchAdminTasks(this.chainId)
    await this.chainModuleInstance.fetchChain({
      id: this.chainId,
      relations: ['salesRepresentative', 'accountManager']
    })
    await this.chainModuleInstance.fetchOnboardingData(this.chainId)
    await this.chainModuleInstance.fetchChainComments(this.chainId)
    await this.userModuleInstance.fetchChainManager(this.chainId)
    await this.userModuleInstance.getAdminUsersList({
      status: EUserStatus.ACTIVE
    })
    await this.permissionsModuleInstance.getUserRoles(+this.chainId)
    await this.chainModuleInstance.fetchOnboardingTemplates()
    if (this.todoId) {
      await this.userModuleInstance.fetchTodosPagination({ todo: this.todoId, query: this.$route.query })
    }

    this.isLoading = false
  }

  async loginAsAdmin (roleId?: number) {
    const token = await api.auth.getChainManagerToken({
      chainId: this.chain.id,
      roleId: roleId || undefined
    })
    const route = this.$router.resolve({
      name: 'management-todo',
      query: {
        token
      }
    })

    this.$locationManager.openNewTab(route.href, true)
  }

  async goPrevTodo () {
    const todo = this.todosPagination.prev
    this.gotoTodo(todo)
  }

  goNextTodo () {
    const todo = this.todosPagination.next
    this.gotoTodo(todo)
  }

  gotoTodo (todo: any) {
    if (todo.alert) {
      this.$router.push({
        name: 'admin-facilities-users-page-todo',
        params: { id: todo.user.id, todo: todo.id },
        query: this.$route.query
      })
    } else {
      if (todo.user) {
        this.$router.push({
          name: 'admin-facilities-users-page-todo',
          params: { id: todo.user.id, todo: todo.id },
          query: this.$route.query
        })
      } else {
        this.$router.push({
          name: 'admin-chain-page-todo',
          params: { id: todo.chain.id, todo: todo.id },
          query: this.$route.query
        })
      }
    }
  }
}
